import http from "../core/http";
const group = 'bags';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createDataRequest =  async (data) => {
    return await http.post(`${group}/create`, data).then(res => res.data).catch(http.defaultCatch);
}

export const updateDataRequest =  async (data) => {
    return await http.post(`${group}/update`, data).then(res => res.data).catch(http.defaultCatch);
}


export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getBagStatusListRequest =  async (data) => {
	return await http.post(`${group}/getBagStatusList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getForwardTypeListRequest =  async (data) => {
	return await http.post(`${group}/getForwardTypeList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getDamageBagClaimListRequest =  async (data) => {
	return await http.post(`${group}/getDamageBagClaimList`, data).then(res => res.data).catch(http.defaultCatch);
}


export const getArrivalFlightListRequest =  async (data) => {
	return await http.post(`caseFiles/getArrivalFlightList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getDepartureFlightListRequest =  async (data) => {
	return await http.post(`caseFiles/getDepartureFlightList`, data).then(res => res.data).catch(http.defaultCatch);
}
